module.exports = __webpack_public_path__ + "static/approve_annual_accounts_browserized-7332c5ec9246852d235b1b8ca8b14b26.png";